/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id, teamIdentifier: ZodTypes.Team.Identifier });

export const GetTeam = {
  id: 'team.get',
  tag: 'Team',
  summary: 'Get organization team',
  description: 'Retrieve a team within an organization',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/team/${params.teamIdentifier}`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            identifier: ZodTypes.Team.Identifier,
            displayName: ZodTypes.Team.DisplayName,
            about: ZodTypes.Team.About.nullish(),
            role: ZodTypes.RBAC.Organization.Roles,
            createdAt: z.date(),
            users: z.array(
              z.strictObject({
                id: ZodTypes.Id,
                firstName: z.string().min(1),
                lastName: z.string().min(1),
                email: z.string().email(),
              }),
            ),
            ssoGroups: z.array(
              z.strictObject({
                groupName: z.string().min(1),
                users: z.array(
                  z.strictObject({
                    id: ZodTypes.Id,
                    firstName: z.string().min(1),
                    lastName: z.string().min(1),
                    email: z.string().email(),
                  }),
                ),
              }),
            ),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
